// Whether a share carries audio, as its sharer reports it: 'unsupported' when the device can't share audio, 'declined'
// when the user chose not to (e.g. refused the RV Share app's record-audio prompt), 'unavailable' when there is none
// and the sharer can't tell why (the browser's screen picker doesn't say).
export const SHARER_AUDIO_STATUSES = [
  'shared',
  'unsupported',
  'declined',
  'unavailable',
] as const;

export type SharerAudioStatus = (typeof SHARER_AUDIO_STATUSES)[number];

interface SharerAudio {
  // The member sharing: for the RV Share app, its app's member, not its page's
  memberId: string;
  status: SharerAudioStatus;
}

export default SharerAudio;

// A status from the server, if it's one this page knows and has its sender: anything else shows nothing
export function toSharerAudio(
  memberId?: string,
  status?: string,
): SharerAudio | null {
  return memberId &&
    (SHARER_AUDIO_STATUSES as readonly string[]).includes(status)
    ? { memberId, status: status as SharerAudioStatus }
    : null;
}
